<template>
  <nav class="navbar navbar-expand-md navbar-dark bg-dark py-0">
    <div class="container-fluid">
      <button
        class="navbar-toggler my-1 ms-auto"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        :aria-label="$localize('ToggleNavigation')"
      >
        <span class="navbar-toggler-icon" />
        <span class="visually-hidden">Toggle navigation</span>
      </button>
      <div
        id="navbarSupportedContent"
        ref="collapsableContainer"
        class="collapse navbar-collapse"
      >
        <ul class="navbar-nav me-auto">
          <li
            v-for="(item, index) in visibleItems"
            :key="index"
            class="nav-item pb-1"
          >
            <router-link
              class="nav-link pb-2"
              :class="{ 'active': item.link == activeLink }"
              :to="item.link"
              active-class="active"
              exact-active-class="active"
              @click="collapseNavbar"
            >
              <span :data-test="item.label">{{ item.label }}</span>
              <span
                v-if="item.link === activeLink"
                class="visually-hidden"
              >{{ $localize('CurrentSectionSummary') }}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script setup lang="ts">
  import { computed, ref } from 'vue';
  import NavBarItem from '@/VueComponents/SiteComponents/Navigation/Types/navBarItem';
  import useBootstrapApi from '@/VueCore/utils/useBootstrapApi';
  
  const props = defineProps<{
    items: NavBarItem[],
    activeLink: string
  }>();
  
  const collapsableContainer = ref<HTMLElement>();
  const bsCollapse = useBootstrapApi(bootstrap => new bootstrap.Collapse(collapsableContainer.value!, { toggle: false }));
  
  const visibleItems = computed(() => {
    return props.items.filter(item => item.condition ?? true);
  })
  
  function collapseNavbar() {
    if (!bsCollapse.value) return;
    
    bsCollapse.value.hide();
  }
</script>